import { features } from 'reactApp/mail-features';

export const enableWorkspaceSuperappMode = features.has('enable-workspace-superapp-mode');
